<template>
  <div>
    <div class="modal-header has-background-info-light">
      <h2 class="window-header subtitle">{{ title }}</h2>
    </div>
    <div class="box">
      <!-- ime -->
      <div class="columns" v-show="isEmployeesVisible">
        <div class="column has-text-centered">
          <label>Zaposleni:</label>
        </div>
        <div class="column has-text-centered is-four-fifths">
          <vue-select
            class="has-background-info-light"
            type="text"
            label="name"
            @option:selected="employeeSelected"
            :disabled="isEmployeesDisabled"
            :clearable="false"
            :options="employees"
            v-model="selectedEmployee"
          />
        </div>
      </div>

      <!-- preview -->
      <div class="columns">
        <div class="column">
          <span v-html="outdoorEventsPresentNote"></span>
        </div>
      </div>

      <!-- Table of outdoor events -->
      <div class="base-demo" v-show="outsideEvents.length > 0 && !isFallback">
        <vue-table-dynamic
          @row-click="tableRowClicked"
          :params="params"
        ></vue-table-dynamic>
      </div>

      <!-- Ipak ručno dodavanje -->
      <div class="mb-5">
        <input type="checkbox" id="checkbox" v-model="isFallback" />
        <label for="checkbox">Dodaj opis ručno</label>
      </div>

      <!-- Fallback text input -->
      <div v-show="isFallback && selectedEmployee">
        <div class="columns">
          <div class="column">
            <input
              class="input has-text-centered has-background-info-light"
              ref="description"
              type="text"
              placeholder="Dodaj opis ručno"
              v-model="selectedItem.note"
            />
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="columns">
        <div class="column">
          <button
            class="button is-info is-light is-rounded"
            ref="saveButton"
            @click="saveAndCloseButtonClicked"
            :disabled="outsideEvents.length == 0 && selectedItem.note === ''"
          >
            SAČUVAJ I ZATVORI
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reportService from "../../services/report.service";
import {
  maskIfEquealsValue,
  getLeavingReasonStringFromId,
} from "../../_helpers/arrangers";

export default {
  name: "EditPrivateExit",

  components: {},

  props: {
    button1Name: String,
    button2Name: String,
    title: String,
    selectedItem: Object,
    selectedStatusId: Number,
    statuses: Array,
    isStatusesVisible: Boolean,
    employees: Array,
    isEmployeesVisible: Boolean,
    departments: Array,
    today: Date,
    tomorrow: Date,
    isSaveAndProceedButtonVisible: Boolean,
  },

  data() {
    return {
      outsideEvents: [],
      selectedDailyLog: null,
      selectedEmployee: null,
      selectedOutsideEvent: null,
      isEmployeesDisabled: false,
      params: {
        data: [
          [
            "ndx",
            "vrijeme izlaska",
            "vrijeme povratka",
            "vrsta izlaska",
            "izabrani izlazak",
          ],
        ],
        header: "row",
        columnWidth: [
          { column: 0, width: 65 },
          { column: 1, width: 120 },
          { column: 2, width: 120 },
          { column: 3, width: 140 },
        ],
        pagination: true,
        pageSize: 50,
        filter: [
          {
            column: 6,
            content: [{ text: "✅", value: "✅" }],
            method: (value, tableCell) => {
              return tableCell.data == "✅";
            },
          },
        ],
      },
      isFallback: false,
    };
  },

  computed: {
    outdoorEventsPresentNote() {
      if (this.outsideEvents.length > 0) {
        return (
          "<p>" +
          this.selectedEmployee.name +
          " " +
          this.selectedEmployee.departmentName +
          ". Izaberi izlazak <b>(izlazak će se pretvoriti u 🔒 privatni)</b>: "
        );
      } else if (this.selectedDailyLog) {
        return (
          "<p>" +
          "Ne postoje izlasci u toku radnog vremena za izabranog zaposlenog." +
          " Zaposleni je napustio firmu u " +
          this.selectedDailyLog?.departureTimeGeneral?.split("T")[1] +
          ".</p>"
        );
      } else {
        return "<p>" + "</p>";
      }
    },

    isSaveAndCloseButtonDisabled() {
      return false;
    },
  },

  updated() {
    // this.focusInput();
  },

  methods: {
    saveAndCloseButtonClicked() {
      if (!this.isFallback) {
        // postoje izlasci
        this.$emit("saveAndCloseClicked", {
          isFallback: this.isFallback,
          selectedOutsideEvent: this.selectedOutsideEvent,
          selectedDailyLog: this.selectedDailyLog,
          selectedItem: null,
        });
        console.log(this.selectedItem);
      } else {
        this.calculateEmployee();
        this.$emit("saveAndCloseClicked", {
          isFallback: this.isFallback,
          selectedOutsideEvent: this.selectedOutsideEvent,
          selectedDailyLog: this.selectedDailyLog,
          selectedItem: this.selectedItem,
        });
        console.log(this.selectedItem);
      }
    },

    // saveAndCloseButtonClicked() {
    //   this.$emit("saveAndCloseClicked", {
    //     selectedOutsideEvent: this.selectedOutsideEvent,
    //     selectedDailyLog: this.selectedDailyLog,
    //   });
    //   console.log(this.selectedItem);
    // },

    focusInput() {
      this.$refs["saveButton"].focus();
    },

    async employeeSelected(employee) {
      console.log(employee);
      console.log(this.today);
      console.log(this.tomorrow);

      this.resetUi();

      // Get DailyLog for this employee
      const dailyLogs = (
        await reportService.GetNormalizedAccessDataByTimeRange(
          this.today,
          this.tomorrow,
          employee.id,
          null
        )
      ).data;

      this.selectedDailyLog = dailyLogs.find(
        (dl) => dl.employeeId == employee.id
      );

      this.outsideEvents = [];

      // Outside events for this employee
      this.selectedDailyLog.outsideEvent.forEach((oe) => {
        if (oe.isLogicallyClosed) {
          this.outsideEvents.push(oe);
        }
      });
      // this.outsideEvents = this.selectedDailyLog.outsideEvent;
      console.log("My selected daily log: ", this.selectedDailyLog);
      console.log("My outside events: ", this.outsideEvents);
      console.log("My selected item: ", this.selectedItem);

      // Select first outside event
      if (this.outsideEvents.length > 0) {
        this.outsideEvents[0].value = "✅";
        this.selectedOutsideEvent = this.outsideEvents[0];
      }

      // Add rows
      this.addRowsFromOutsideEvents();

      console.log("Selected outside event: ", this.selectedOutsideEvent);
    },

    addRowsFromOutsideEvents() {
      this.outsideEvents.forEach((oe) => {
        this.params.data.push([
          oe.outsideEventId,
          maskIfEquealsValue(
            new Date(oe.departureTime).toLocaleTimeString("sr-latn-cs"),
            "01:00:00"
          ),
          maskIfEquealsValue(
            new Date(oe.arrivalTime).toLocaleTimeString("sr-latn-cs"),
            "01:00:00"
          ),
          getLeavingReasonStringFromId(oe.leavingReasonId),
          oe.value,
        ]);
      });
    },

    employeeFromId(id) {
      return this.employees.find((x) => x.id === id);
    },

    tableRowClicked(rowId, row) {
      console.log("BODIROGA!!", rowId, row);

      this.selectedOutsideEvent = this.outsideEvents.find(
        (oe) => oe.outsideEventId == row[0]
      );

      this.outsideEvents.forEach((oe) => {
        oe.value = null;
      });
      this.selectedOutsideEvent.value = "✅";
      this.resetUi();

      this.addRowsFromOutsideEvents();

      console.log("Selected outide event: ", this.selectedOutsideEvent);
    },

    resetUi() {
      this.params.data = [
        [
          "ndx",
          "vrijeme izlaska",
          "vrijeme povratka",
          "vrsta izlaska",
          "izabrani izlazak",
        ],
      ];

      // this.selectedItem = {
      //   boldText: "",
      //   employeeId: null,
      //   note: "",
      //   previewString: "",
      // };
    },

    calculateEmployee() {
      if (this.isEmployeesVisible !== false) {
        this.selectedItem.boldText =
          this.selectedEmployee.name +
          " " +
          this.selectedEmployee.departmentName +
          " - ";

        this.selectedItem.employeeId = this.selectedEmployee.id;
      }
      console.log("Selected item: ", this.selectedItem);
    },
  },
};
</script>
